export const LATE_SALES_ORDER_STATUSES = Object.freeze([
  'In Production',
  'Shipped',
  'Ready to be Invoiced',
  'Invoiced',
  'Closed',
]);

export function getManualLateSalesOrderStatuses(roleSet = new Set()) {
  const roles = new Set([...roleSet].map((role) => String(role || '').trim().toLowerCase()));
  if (roles.has('administrator') || roles.has('finance-rep') || roles.has('purchasing-rep')) {
    return [...LATE_SALES_ORDER_STATUSES];
  }
  return [];
}

export function filterManualSalesOrderStatusOptions(options, roleSet) {
  const allowed = new Set(getManualLateSalesOrderStatuses(roleSet));
  return options.filter((option) => option.type === 'SO' && allowed.has(option.value));
}
